import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Grid,
  Container,
  Box,
  Chip,
  Skeleton,
} from "@mui/material";
import { CustomContainedButton } from "../../components/OutlinedButton";
import { getPilgrimagesForSlider } from "../../services/sanityApi";

// Pelerinaje hardcodate - păstrate ca fallback și date istorice
const HARDCODATE_EXTERNE = [
  {
    id: "hc-athos",
    title: "Pelerinaj în Sfântul Munte Athos",
    date: "8–13 Septembrie 2025 & 5-10 Octombrie 2025",
    cost: "675 Euro",
    transport: "Autocar + Feribot",
    path: "/pelerinaje/athos",
    featuredImage: "/images/athos_oct_25.jpeg",
    category: "pelerinaje-externe",
  },
  {
    id: "hc-moldova",
    title: "Pelerinaj în Republica Moldova",
    date: "13-17 August 2025",
    cost: "1500 LEI",
    transport: "Autocar",
    path: "/pelerinaje/republica-moldova",
    featuredImage: "/images/repMoldova.jpeg",
    category: "pelerinaje-externe",
  },
  {
    id: "hc-egipt",
    title: "Pelerinaj în Egipt",
    date: "27 Octombrie – 4 Noiembrie 2025",
    cost: "1200 Euro",
    transport: "Avion + Autocar",
    path: "/pelerinaje/egipt",
    featuredImage: "/images/egipt.jpeg",
    category: "pelerinaje-externe",
  },
  {
    id: "hc-cappadocia",
    title: "Pelerinaj în Cappadocia și Asia Mică",
    date: "19-27 Februarie 2025",
    cost: "1100 Euro",
    transport: "Avion + Autocar",
    path: "/pelerinaje/cappadocia",
    featuredImage: "/images/IMG_5655.JPG",
    category: "pelerinaje-externe",
  },
  {
    id: "hc-grecia",
    title: "Pelerinaj în Grecia",
    date: "21-28 Mai 2025",
    cost: "1100 Euro",
    transport: "Avion + Autocar",
    path: "/pelerinaje/grecia",
    featuredImage: "/images/IMG_5651.JPG",
    category: "pelerinaje-externe",
  },
  {
    id: "hc-israel",
    title: "Pelerinaj în Israel",
    date: "9-13 Mai 2025",
    cost: "850 Euro",
    transport: "Avion + Autocar",
    path: "/pelerinaje/israel",
    featuredImage: "/images/israel.jpeg",
    category: "pelerinaje-externe",
  },
];

const HARDCODATE_INTERNE = [
  {
    id: "hc-transilvania",
    title: "Pelerinaj în Transilvania",
    date: "1-3 August 2025",
    cost: "750 LEI",
    transport: "Autocar",
    path: "/pelerinaje/transilvania",
    featuredImage: "/images/transilvania.jpeg",
    category: "pelerinaje-interne",
  },
  {
    id: "hc-dobrogea",
    title: "Pelerinaj în Dobrogea",
    date: "3-6 Iulie 2025",
    cost: "1000 LEI",
    transport: "Autocar",
    path: "/pelerinaje/dobrogea-delta",
    featuredImage: "/images/dobrogea_delta_iulie.jpeg",
    category: "pelerinaje-interne",
  },
  {
    id: "hc-oltenia",
    title: "Pelerinaj în Oltenia",
    date: "5-7 Septembrie 2025",
    cost: "750 LEI",
    transport: "Autocar",
    path: "/pelerinaje/oltenia",
    featuredImage: "/images/oltenia.jpeg",
    category: "pelerinaje-interne",
  },
  {
    id: "hc-moldova-bucovina",
    title: "Pelerinaj în Moldova și Bucovina",
    date: "14-16 Martie 2025",
    cost: "1000 LEI",
    transport: "Autocar",
    path: "/pelerinaje/moldova",
    featuredImage: "/images/IMG_5648.JPG",
    category: "pelerinaje-interne",
  },
  {
    id: "hc-brancoveni",
    title: "Pelerinaj Pe urmele Sfinților Brancoveni",
    date: "26-28 Septembrie 2025",
    cost: "800 LEI",
    transport: "Autocar",
    path: "/pelerinaje/romania-grecia",
    featuredImage: "/images/brancovineni_sept.jpeg",
    category: "pelerinaje-interne",
  },
  {
    id: "hc-banat",
    title: "Pelerinaj în Banat și Cazanele Dunării",
    date: "25-27 Aprilie 2025",
    cost: "1000 LEI",
    transport: "Autocar",
    path: "/pelerinaje/banat-cazane",
    featuredImage: "/images/IMG_5649.JPG",
    category: "pelerinaje-interne",
  },
  {
    id: "hc-bucuresti",
    title: "Pelerinaj în București și împrejurimi",
    date: "24-26 Octombrie 2025",
    cost: "800 LEI",
    transport: "Autocar",
    path: "/pelerinaje/bucuresti",
    featuredImage: "/images/bucuresti_24_sept.jpeg",
    category: "pelerinaje-interne",
  },
];

const PelerinajCard = ({ article }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (article.path) {
      navigate(article.path);
    } else {
      navigate(`/articole/${article.slug}`);
    }
  };

  const truncatedExcerpt =
    article.excerpt && article.excerpt.length > 120
      ? article.excerpt.substring(0, 120) + "..."
      : article.excerpt || "";

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        boxShadow: "none",
        border: "1px solid lightgrey",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      {article.featuredImage ? (
        <CardMedia
          component="img"
          image={article.featuredImage}
          alt={article.title}
          sx={{ height: 220, objectFit: "cover" }}
        />
      ) : (
        <Box
          sx={{
            height: 220,
            background: "linear-gradient(135deg, #800020 0%, #BE9257 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography sx={{ fontSize: "2rem", color: "rgba(255,255,255,0.6)" }}>
            ✝
          </Typography>
        </Box>
      )}

      <CardContent
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          p: 3,
        }}
      >
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 1.5 }}>
          {article.date && (
            <Chip
              label={article.date}
              size="small"
              sx={{
                backgroundColor: "#FEF8E8",
                color: "#800020",
                fontFamily: "Inter",
                fontSize: "0.75rem",
                border: "1px solid #BE9257",
              }}
            />
          )}
          {article.cost && (
            <Chip
              label={article.cost}
              size="small"
              sx={{
                backgroundColor: "#FFF8E1",
                color: "#6D4C00",
                fontFamily: "Inter",
                fontSize: "0.75rem",
                border: "1px solid #FFD54F",
                fontWeight: 600,
              }}
            />
          )}
          {article.transport && (
            <Chip
              label={article.transport}
              size="small"
              sx={{
                backgroundColor: "#f5f5f5",
                color: "#444",
                fontFamily: "Inter",
                fontSize: "0.75rem",
                border: "1px solid #ddd",
              }}
            />
          )}
        </Box>

        <Typography
          variant="h6"
          component="h3"
          sx={{
            fontFamily: "Libre Baskerville",
            fontWeight: 700,
            fontSize: { xs: "0.95rem", sm: "1rem" },
            mb: 1.5,
            lineHeight: 1.4,
            color: "#1a1a1a",
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {article.title}
        </Typography>

        {truncatedExcerpt && (
          <Typography
            variant="body2"
            sx={{
              fontFamily: "Inter",
              color: "#555",
              lineHeight: 1.6,
              fontSize: "0.875rem",
              flexGrow: 1,
              mb: 2,
            }}
          >
            {truncatedExcerpt}
          </Typography>
        )}

        <Box sx={{ mt: "auto", pt: 2 }}>
          <CustomContainedButton
            onClick={handleClick}
            text={article.path ? "Vezi Detalii" : "Citește mai mult"}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

const CardSkeleton = () => (
  <Card
    sx={{
      display: "flex",
      flexDirection: "column",
      height: "100%",
      borderRadius: "8px",
      border: "1px solid #f0ece4",
      overflow: "hidden",
    }}
  >
    <Skeleton variant="rectangular" height={220} />
    <CardContent sx={{ p: 3 }}>
      <Box sx={{ display: "flex", gap: 1, mb: 1.5 }}>
        <Skeleton height={24} width="40%" />
        <Skeleton height={24} width="30%" />
      </Box>
      <Skeleton height={20} />
      <Skeleton height={20} />
      <Skeleton height={20} width="80%" />
    </CardContent>
  </Card>
);

export const ListaPelerinaje = () => {
  const [sanityExterne, setSanityExterne] = useState([]);
  const [sanityInterne, setSanityInterne] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    Promise.all([
      getPilgrimagesForSlider("pelerinaje-externe", 20),
      getPilgrimagesForSlider("pelerinaje-interne", 20),
    ])
      .then(([externe, interne]) => {
        setSanityExterne(externe);
        setSanityInterne(interne);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.replace("#", ""));
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 200);
      }
    }
  }, [location]);

  // Sanity primul (cele mai noi anunțuri), hardcodate după
  const externe = [...sanityExterne, ...HARDCODATE_EXTERNE];
  const interne = [...sanityInterne, ...HARDCODATE_INTERNE];

  return (
    <Container className="py-8" sx={{ height: "100%", mt: 12, mb: 12 }}>
      <Typography
        variant="h4"
        id="externe"
        component="h2"
        sx={{
          fontWeight: 700,
          textAlign: "left",
          fontFamily: "Libre Baskerville",
          color: "black",
          mb: 5,
          borderBottom: `2px solid #800020`,
          paddingBottom: "10px",
        }}
      >
        Pelerinaje Externe
      </Typography>
      <Grid container spacing={3}>
        {loading
          ? Array.from({ length: 3 }).map((_, i) => (
              <Grid item xs={12} md={4} key={i}>
                <CardSkeleton />
              </Grid>
            ))
          : externe.map((pelerinaj) => (
              <Grid item xs={12} md={4} key={pelerinaj.id}>
                <PelerinajCard article={pelerinaj} />
              </Grid>
            ))}
      </Grid>

      <Typography
        variant="h4"
        component="h2"
        id="interne"
        sx={{
          fontWeight: 700,
          textAlign: "left",
          fontFamily: "Libre Baskerville",
          color: "black",
          mb: 5,
          mt: 12,
          borderBottom: `2px solid #800020`,
          paddingBottom: "10px",
        }}
      >
        Pelerinaje Interne
      </Typography>
      <Grid container spacing={3}>
        {loading
          ? Array.from({ length: 3 }).map((_, i) => (
              <Grid item xs={12} md={4} key={i}>
                <CardSkeleton />
              </Grid>
            ))
          : interne.map((pelerinaj) => (
              <Grid item xs={12} md={4} key={pelerinaj.id}>
                <PelerinajCard article={pelerinaj} />
              </Grid>
            ))}
      </Grid>
    </Container>
  );
};

export default ListaPelerinaje;
